import { render, staticRenderFns } from "./task-contract-update.vue?vue&type=template&id=96637794&scoped=true&"
import script from "./task-contract-update.vue?vue&type=script&lang=js&"
export * from "./task-contract-update.vue?vue&type=script&lang=js&"
import style0 from "./task-contract-update.vue?vue&type=style&index=0&id=96637794&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96637794",
  null
  
)

export default component.exports